import ApiResourceManager from '../ApiResourceManager';

/**
 * The one-time Go Live choice to turn the guest service fee on for a partner
 * (reseller-owned) restaurant, or skip it. Company-scoped through the usual
 * on-behalf headers. The backend answers 403 for merchants and direct
 * restaurants, and 409 (`service_fee_already_decided`) for a second decision.
 */
export default class ServiceFeeDecisionManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/service-fee-decision',
    });

  /**
   * @param {{ decision: 'enabled'|'skipped', percentage?: number, max_amount?: number }} data
   *   `max_amount` in minor units; both are ignored by the backend when the
   *   partner does not allow restaurants to change the fee.
   */
  decide = (data) =>
    this.request({
      method: 'PUT',
      url: '/service-fee-decision',
      data,
    });
}
